import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { RtAnalyticsModule } from '@recruitee/analytics';

import { TooltipModule } from '../tooltip/tooltip.module';
import { CandidatesAvatarsComponent } from './candidates-avatars.component';

@NgModule({
  imports: [CommonModule, RtAnalyticsModule, TooltipModule, CandidatesAvatarsComponent],
  exports: [CandidatesAvatarsComponent],
})
export class CandidatesAvatarsModule {}

export { CandidatesAvatarsComponent } from './candidates-avatars.component';
